import Tippy from '@tippy.js/react'
import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import axios, { CancelTokenSource } from 'axios';
import UserNotificationsMenuItem from 'components/layout/UserNotificationsMenuItem';
import OptionsModal from 'components/OptionsModal';
import { SidebarConsumerRenderProps } from 'components/sidebar/SidebarContext';
import TwoStepAuthModal from 'components/TwoStepAuthModal';
import Logo from 'Logo';
import moment from "moment";
import * as React from 'react';
import { Component, createRef, LegacyRef } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { RouterProps } from 'react-router';
import { UserNotificationConsumerRenderProps, withUserNotificationContext } from 'routes/UserNotificationsContext';
import { Button, Dropdown, Header as SemanticHeader, Icon, Item, Menu } from 'semantic-ui-react';
import { saveUserConfig } from 'services/userConfigServices';
import styled from 'styled-components';
import { AccountMandateDto, UpsertUserConfigDto } from 'ts-types/api.types';
import { noop } from 'utils/functionUtils';
import { supportedLanguages } from 'utils/localizationUtils';
import { withRouterWorkaround } from 'utils/workaroundUtils';

const cancelTokenSource = axios.CancelToken.source();

const StyledTopWrapper = styled.div`
  height: auto;
  box-shadow: 5px 0 3px 0 #d5d5d5;
  z-index: 55;

  & .notification-menu-item.item {
    padding: 0.3rem;

    .notification-div {
      padding: 0.5rem 0.7rem;
      background: rgba(163, 51, 200, 0.35);
      color: rgba(255, 255, 255, 0.75);
      border-radius: 1rem;
      margin: 0.5rem;

      &.active {
        background: #a333c8;
        color: white;
      }
    }
  }
`;

const StyledMenu = styled(Menu)`
  &.ui.menu {
    border-radius: 0;

    //border-bottom: 1px solid #A29F9F;
    border-bottom: 1px solid #95A8A3;

    //background: #C4C4C4;
    //background: #334A44;
    //background: #a9a6a6;
    background: #A4B5AF;

    .item {
      color: white;
      text-decoration: none;

      :hover {
        color: #eaeaea;
      }
    }
  }
`;

const StyledLogo = styled(Logo)`
  &.logo-icon {
    transform: scale(0.6);
    margin-top: 0.2rem;
    margin-left: -2.5rem;
    height: 2rem;
  }
`;

const StyledLanguageDropdown = styled(Dropdown)`
  height: 100%;
`;

const StyledUserInfo = styled.div`
  width: 12em;
  white-space: nowrap;
`;

const StyledLangContainer = styled.div`
  width: 100%;
  white-space: nowrap;
`;

const StyledOptions = styled.div`
  width: 8em;
  white-space: nowrap;
`;

const StyledItemContent = styled(Item.Content)`
  display: inline-block;
  vertical-align: middle;
`;

const StyledTreaterHeaderContent = styled.div`
  max-width: 8rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  outline: none;
`;

const StyledUserHeaderContent = styled.div`
  max-width: 10rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  outline: none;
`;

const StyledFooterContent = styled.div`
  font-size: 0.85rem;
  margin-top: 0.2rem;
  max-width: 10rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  outline: none;
`;

const StyledDiv = styled.div`
  padding: 0 !important;
`;

const ConfirmMandatePopupBox = styled.div`

  padding: 0.5rem;

  .ui.header {
    text-align: left;
  }

  .actions-row {
    display: flex;
    margin-top: 1.8rem;

    button {
      margin-right: 0.5rem;
    }
  }
`;

interface Props extends AuthConsumerRenderProps,
    MessageSourceProps,
    RouterProps,
    UserNotificationConsumerRenderProps,
    SidebarConsumerRenderProps {
}

interface State {
  fullNameRef: LegacyRef<any>,
  currentMandateRef: LegacyRef<any>,
  langRef: LegacyRef<any>,
  showFullNamePopup: boolean,
  showCurrentMandatePopup: boolean,
  confirmMandateOpen: boolean,
  showLangPopup: boolean,
  mandateId: number,
  optionsModalOpen: boolean,
  user2faModalOpen: boolean,
  requiredDoctorActionsModalOpen: boolean,
  requiredDoctorActionsKey: number,
  cancelTokenSource: CancelTokenSource
}

class Header extends Component<Props, State> {

  state = {
    fullNameRef: createRef<any>(),
    currentMandateRef: createRef<any>(),
    langRef: createRef<any>(),
    showFullNamePopup: false,
    showCurrentMandatePopup: false,
    confirmMandateOpen: false,
    showLangPopup: false,
    mandateId: -1,
    optionsModalOpen: false,
    user2faModalOpen: false,
    requiredDoctorActionsModalOpen: false,
    requiredDoctorActionsKey: 1,
    cancelTokenSource
  };

  logoutAndRedirect = () => {

    const {logout, history} = this.props;
    if (logout) {
      logout();
      history.push("/login");
    }
  };

  componentDidMount() {

    const {
      fullNameRef: {current: fullName},
      currentMandateRef: {current: mandate},
      langRef: {current: language}
    } = this.state;

    this.setState({
      showFullNamePopup: fullName.offsetWidth < fullName.scrollWidth,
      showCurrentMandatePopup: mandate.offsetWidth < mandate.scrollWidth,
      showLangPopup: language.offsetWidth < language.scrollWidth
    });
  }

  openConfirmMandate = (mandateId: number) => {
    this.setState({
      confirmMandateOpen: true,
      mandateId: mandateId
    })
  };

  closeConfirmMandate = () => {
    this.setState({
      confirmMandateOpen: false
    })
  };

  setUserConfig = () => {

    const {updateUserConfig} = this.props;
    const {currentMandateRef: {current: mandate}, mandateId, cancelTokenSource} = this.state;

    this.setState({
      showCurrentMandatePopup: false
    });

    const upsertUserConfig: Partial<UpsertUserConfigDto> = {
      mandateId: mandateId
    };

    saveUserConfig(upsertUserConfig, cancelTokenSource)
        .then(response => {
          // updateUserConfig!(response);
          // this.setState({
          //   showCurrentMandatePopup: mandate.offsetWidth < mandate.scrollWidth,
          //   confirmMandateOpen: false,
          //   mandateId: -1
          // });
          window.location && window.location.reload();
        })
        .catch(noop);
  };

  changeLanguage = (language: string) => {

    const {currentUser, updateUserConfig, updateLanguage} = this.props;
    const {cancelTokenSource} = this.state;

    this.setState({
      showLangPopup: false
    });

    const upsertUserConfig: Partial<UpsertUserConfigDto> = {
      mandateId: currentUser && currentUser.userConfig.mandateId,
      language: language
    };

    updateLanguage(language);

    saveUserConfig(upsertUserConfig, cancelTokenSource).then(response => {
      updateUserConfig!(response);
    }).catch(noop);
  };

  toggleOptionsModal = () => {
    this.setState(({optionsModalOpen}: State) => ({
      optionsModalOpen: !optionsModalOpen
    }))
  };

  toggleUser2faModal = () => {
    this.setState(({user2faModalOpen}: State) => ({
      user2faModalOpen: !user2faModalOpen
    }))
  };

  getMandateName = () => {

    const {currentUser} = this.props;

    const mandate = currentUser!.accountMandates.find(
        mandate => mandate.id == currentUser!.userConfig.mandateId
    );

    return mandate!.name
  };

  getLanguage = () => {

    const {currentUser} = this.props;

    return currentUser!.userConfig.language
        ? currentUser!.userConfig.language
        : "de";
  };

  render(): React.ReactNode {

    const {getMessage, currentUser, options} = this.props;
    const {confirmMandateOpen, optionsModalOpen, user2faModalOpen} = this.state;

    const treater = options.currentTreater.name ? options.currentTreater.name : "";
    const treaterHover = `${getMessage("currentTreater")}: ${treater}`;
    const workDate = moment(options.workDate).format("DD.MM.YYYY");
    const workDateHover = `${getMessage("workDate")}: ${workDate}`;

    const accountMandates = currentUser ? currentUser.accountMandates
        .map((accountMandate: AccountMandateDto, index: number) => {
          const currentMandateId = currentUser.userConfig.mandateId;
          return (
              <Dropdown.Item
                  key={index}
                  onClick={() => this.openConfirmMandate(accountMandate.id)}
                  disabled={currentMandateId == accountMandate.id}
              >
                <Icon name={currentMandateId == accountMandate.id ? "caret right" : undefined}/>
                {accountMandate.name}
              </Dropdown.Item>
          );
        }) : [];

    const availableLanguages = supportedLanguages.filter(lang => lang !== this.getLanguage());
    const languages = availableLanguages.map((lang, index) => (
        <Dropdown.Item key={index}
                       onClick={() => this.changeLanguage(lang)}
        >
          {lang.toUpperCase()}
        </Dropdown.Item>
    ));

    return (
        <StyledTopWrapper>
          <StyledMenu>

            <StyledLogo/>

            <Menu.Menu position="right">

              <UserNotificationsMenuItem/>

              <Menu.Item onClick={this.toggleOptionsModal}>
                <StyledOptions>
                  <StyledItemContent>
                    <Tippy duration={120} content={treaterHover}>
                      <StyledTreaterHeaderContent>
                        {treater}
                      </StyledTreaterHeaderContent>
                    </Tippy>
                    <Tippy duration={120} content={workDateHover}>
                      <StyledFooterContent>
                        {workDate}
                      </StyledFooterContent>
                    </Tippy>
                  </StyledItemContent>
                </StyledOptions>
              </Menu.Item>

              <Tippy
                  content={this.confirmMandatePopupContent()}
                  isVisible={confirmMandateOpen}
                  theme="light"
                  placement="bottom-end"
                  interactive
                  onHide={() => {
                    confirmMandateOpen ? this.closeConfirmMandate() : ""
                  }}
              >
                <StyledDiv className="item">
                  <Dropdown trigger={this.userDropdownTrigger()} className="link item">
                    <Dropdown.Menu>
                      <Dropdown.Header>Mandates</Dropdown.Header>
                      {accountMandates}
                      <Dropdown.Divider/>
                      <Dropdown.Item onClick={this.toggleUser2faModal}>
                        <Icon name="qrcode"/>
                        {getMessage('header.navigation.2fa')}
                      </Dropdown.Item>
                      <Dropdown.Divider/>
                      <Dropdown.Item onClick={this.logoutAndRedirect}>
                        <Icon name="log out"/>
                        {getMessage('header.navigation.logout')}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </StyledDiv>
              </Tippy>

              <StyledDiv className="item">
                <StyledLanguageDropdown trigger={this.languageDropdownTrigger()} className="link item">
                  <Dropdown.Menu>
                    {languages}
                  </Dropdown.Menu>
                </StyledLanguageDropdown>
              </StyledDiv>

              {
                  optionsModalOpen &&
                  <OptionsModal
                      modalOpen={optionsModalOpen}
                      onCloseModal={this.toggleOptionsModal}
                  />
              }

              {
                  user2faModalOpen &&
                  <TwoStepAuthModal
                      modalOpen={user2faModalOpen}
                      onCloseModal={this.toggleUser2faModal}
                  />
              }
            </Menu.Menu>
          </StyledMenu>
        </StyledTopWrapper>
    );
  }

  languageDropdownTrigger = (): React.ReactNode => {

    const {showLangPopup, langRef} = this.state;

    let lang = this.getLanguage().toUpperCase();

    return (
        <StyledLangContainer>
          <StyledItemContent>
            <Tippy duration={120} content={lang} isEnabled={showLangPopup}>
              <StyledUserHeaderContent ref={langRef}>
                {lang}
              </StyledUserHeaderContent>
            </Tippy>
          </StyledItemContent>
        </StyledLangContainer>
    )
  };


  userDropdownTrigger = (): React.ReactNode => {

    const {currentUser} = this.props;
    const {showFullNamePopup, showCurrentMandatePopup, fullNameRef, currentMandateRef} = this.state;

    let fullName = currentUser
        ? `${currentUser.firstName} ${currentUser.name}`
        : '';

    let currentMandate = currentUser ? this.getMandateName() : "";

    return (
        <StyledUserInfo>
          <Icon size={'large'} name="user circle"/>
          <StyledItemContent>
            <Tippy duration={120} content={fullName} isEnabled={showFullNamePopup}>
              <StyledUserHeaderContent ref={fullNameRef}>
                {fullName}
              </StyledUserHeaderContent>
            </Tippy>
            <Tippy duration={120} content={currentMandate} isEnabled={showCurrentMandatePopup}>
              <StyledFooterContent ref={currentMandateRef}>
                {currentMandate}
              </StyledFooterContent>
            </Tippy>
          </StyledItemContent>
        </StyledUserInfo>
    )
  };

  confirmMandatePopupContent = (): any => {

    const {getMessage, getMessageWithNamedParams, currentUser} = this.props;
    const {mandateId} = this.state;

    let foundMandate;
    if (currentUser) {
      foundMandate = currentUser.accountMandates.find((mandate: AccountMandateDto) => {
        return mandate.id == mandateId;
      });
    }

    const mandateName = foundMandate ? foundMandate.name : "";

    return (
        <ConfirmMandatePopupBox>
          <SemanticHeader>
            {getMessageWithNamedParams("confirmMandate", {mandate: mandateName})}
          </SemanticHeader>

          <div className={"actions-row"}>
            <Button compact primary onClick={this.setUserConfig}>{getMessage("button.yes")}</Button>
            <Button compact onClick={this.closeConfirmMandate}>{getMessage("button.no")}</Button>
          </div>
        </ConfirmMandatePopupBox>
    )
  }

}

export default withRouterWorkaround(
    withAuthContext(
        withUserNotificationContext(
            withMessages(Header))));
